import { useNavigate } from 'react-router-dom';
import { Tabs } from '../primitives';

export type SettingsWorkItemsTab = 'types' | 'property-library' | 'pipelines';

const ITEMS = [
  { value: 'types', label: 'Types & hierarchy' },
  { value: 'property-library', label: 'Property library' },
  { value: 'pipelines', label: 'Status pipelines' }
] as const;

export function SettingsWorkItemsTabs({
  active,
  onChange
}: {
  active: SettingsWorkItemsTab;
  onChange: (next: SettingsWorkItemsTab) => void;
}) {
  return (
    <Tabs
      items={ITEMS as unknown as { value: string; label: string }[]}
      value={active}
      onChange={(v) => onChange(v as SettingsWorkItemsTab)}
      label="Work Item settings sections"
      dataTestId="settings-work-items-tabs"
    />
  );
}

export function useGoToSettingsWorkItemsTab() {
  const navigate = useNavigate();
  return (tab: SettingsWorkItemsTab) => {
    navigate(`/settings/work-items?tab=${tab}`);
  };
}
